<section class="searchresult-splash">
  <div class="content">
    <div>
      <h1 class="finder-title left-border-heading">
        Schedule
      </h1>
      <p class="finder-heading">Search online and see schedules from over 23 different RoRo lines.</p>
      <h2 class="finder-subHeading">Select vessel to see the schedule.</h2>
    </div>
    <div class="container">
      <div class="search-section">
        <form [formGroup]="portForm" class="search-section-right" (ngSubmit)="getDetails()">
          <div class="select-sec select-date-sec">
            <label></label>
            <div class="select-section-relative input-section">
              <p-calendar formControlName="date" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy" (onBlur)="reset('5')">
              </p-calendar>
            </div>
          </div>
          <div class="select-sec revert-arrow">
          </div>
          <div class="select-sec">
            <div class="select-section-relative">
              <div class="input-section pRel">
                <p-dropdown formControlName="shippingLineId" [options]="shippinglineslist" optionLabel="companyName"
                  [filter]="true" filterMatchMode="startsWith" placeholder="Select Shippingline"
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onShippinglineChange($event)">
                </p-dropdown>
              </div>
            </div>
            <div class="select-section-relative">
              <div class=" pRel">
                <p-dropdown formControlName="vesselId" [options]="vesselslist" optionLabel="vesselsName" [filter]="true"
                  filterMatchMode="startsWith" placeholder="Select Vessel" 
                  [itemSize]="31" [virtualScroll]="true" (onChange)="onVesselChange($event)">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="select-sec revert-arrow">
          </div>
          <div class="select-sec">
            <div class="select-section-relative">            
              <div class="input-section pRel">
                <p-dropdown formControlName="departurePort" [options]="departurePorts" optionLabel="label"
                [filter]="true" filterMatchMode="startsWith" placeholder="Select Departure Port" 
                [itemSize]="31" [virtualScroll]="true" (onChange)="onDeparturePortChange($event)">
              </p-dropdown>
               
              </div>
            </div>
            <div class="select-section-relative">
              <div class=" pRel">
                <p-dropdown formControlName="arrivalPort" [options]="arrivalPorts" optionLabel="label"
                  [filter]="true" filterMatchMode="startsWith" placeholder="Select Arrival Port"
                  [itemSize]="31" [virtualScroll]="true">
                </p-dropdown>                
              </div>
            </div>
          </div>
          
          
          <div class="btn-go-sec">
            <button pButton type="submit" label="Submit"
              class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<section class="bg-image-splash">

</section>